import React from "react";
import { FiSearch } from "react-icons/fi";
import styles from "../ViewOptionsPanel.module.scss";

const SectionSearch = ({
  value,
  onChange,
  placeholder = "Ara...",
  ariaLabel = "Filtrede ara",
}) => (
  <div className={styles.pickerSearchWrap}>
    <FiSearch size={14} className={styles.pickerSearchIcon} aria-hidden />
    <input
      type="search"
      className={styles.pickerSearch}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel}
    />
  </div>
);

export default SectionSearch;
